<template>
  <v-container fluid>
    <div v-if="isCliente == 0">
      <section class="content-header">
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Tipo de Estatus (PickUp)</v-toolbar-title>
          <v-divider class="mx-4" vertical />
          <v-text-field
            v-model="searcher"
            append-icon="mdi-file-search"
            label="Buscar"
            single-line
            hide-details
            clearable
            max-width="200px"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-divider class="mx-4" vertical />
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  x-large
                  @click="fillCbxShowModal()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-database-plus</v-icon>
                </v-btn>
              </template>
              <span>Crear Nuevo</span>
            </v-tooltip>
            <v-divider class="mx-4" vertical />
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="fillEstatus()"
                  x-large
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-table-refresh</v-icon>
                </v-btn>
              </template>
              <span>Actualizar Tabla</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
      </section>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="estatus"
            :search="searcher"
            class="elevation-1"
          >
            <template v-slot:item.acciones="{ item }">
              <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="info"
                    @click="fillCbxShowModal(true, item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    @click="deleteItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!--FORMULARIO MODAL -->      
        <v-dialog
          v-model="dialog"
          :fullscreen="fullScreen"
          transition="dialog-bottom-transition"
          persistent
          width="800"
        >     
                <v-card elevation="24" outlined>
                  <v-toolbar dark dense color="#96298A">                    
                    <v-toolbar-title>Estatus</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-divider vertical />
                    <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
                      <v-icon>mdi-window-maximize</v-icon>
                    </v-btn>
                    <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
                      <v-icon>mdi-window-minimize</v-icon>
                    </v-btn>
                    <v-divider vertical />
                    <v-btn icon dark @click="closeAndResetCbx()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            label="Código"
                            v-model="camposBD.codigo"
                            ref="codigo"
                            :rules="[reglas.requeridoTxt]"
                            required
                            append-icon="mdi-chevron-down-circle"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            label="Descripción"
                            v-model="camposBD.descripcion"
                            ref="descripcion"
                            :rules="[reglas.requeridoTxt]"
                            required
                            append-icon="mdi-edit"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>           
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="error darken-1" @click="closeAndResetCbx()">
                      Cancelar
                      <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                    <v-btn outlined color="primary darken-1" @click="saveItem()">
                      Guardar
                      <v-icon dark>mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>              
        </v-dialog>      
      <!--FORMULARIO MODAL -->
    </div>
    <div v-else>
      <h1>Usted no tiene permisos para ver esta sección</h1>
    </div>
  </v-container>
</template>
<script>
import apicon from '../plugins/apicon';
export default {
  created: function () {},
  data() {
    return {
      fullScreen: false,
      searcher: "",
      dialog: false,
      valid: true,
      modalEditando: false,
      estatus: [],
      headers: [
        { text: "Código", value: "codigo" },
        { text: "Descripción", value: "descripcion" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      /*Variables*/
      camposBD: {
        id: 0,
        codigo: null,
        descripcion: null
      },      
      isCliente: 1,
      /*Variables*/
    };
  },
  methods: {
    //Obtener los datos para rellenar la tabla del index
    fillEstatus: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + 'estatusp').then((result) => {
        this.estatus = result;
      });
    },
    //Guardar o Actualizar
    saveItem: function () {
      if (this.$refs.form.validate()) {
        //Actualizar
        if (this.modalEditando) {          
          apicon.updateDataApi(apicon.getApiBaseUrl() + 'estatusp/' + this.camposBD.id, this.camposBD).then((result) => {
            this.fillEstatus();
            this.closeAndResetCbx();
            this.$swal(result.message);
          });
        } else {
          //Guardar
          apicon.saveDataApi(apicon.getApiBaseUrl() + 'estatusp', this.camposBD).then((result) => {
            this.fillEstatus();
            this.limpiarCampos();
            this.$swal(result.message);
          });
        }
      }
    },
    //Eliminar
    deleteItem: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {          
          apicon.deleteDataApi(apicon.getApiBaseUrl() + 'estatusp/' + item.id).then((result) => {
            self.fillEstatus();
            this.$swal(result.message);
          });
        }
      });
    },
    fillCbxShowModal: function (editando = false, item = []) {
      this.modalEditando = editando;
      if (editando) {
        Object.keys(this.camposBD).forEach((key) => {
          this.camposBD[key] = item[key];
        });                
      } else {
        this.limpiarCampos();
      }
      this.dialog = true;
    },
    limpiarCampos: function () {
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = null;
      });
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeAndResetCbx: function () {
      this.limpiarCampos();
      this.dialog = false;
    },
  },
  mounted() {
    apicon.setAuthHeaders();
    this.fillEstatus();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>